import React from 'react';
import { CTAButton } from './CTAButton';
export function TransformationSection() {
  const transformations = [{
    image: 'https://cdn.magicpatterns.com/uploads/j1bAnDNAMFiUHYX4me3fWR/Rektusdiastase_Therapie__Was_Du_im_Alltag_tun_kannst.jpg',
    name: 'Romina, 51 años',
    result: '−3 kg',
    weeks: '4 semanas',
    rotate: -2
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9nVCywdEji5D2cZA4Sesut/Sarah-C-side-1024x1024.webp',
    name: 'Carolina, 39 años',
    result: 'Abdomen plano',
    weeks: '4 semanas',
    rotate: 1.5
  }];
  const outcomes = ['Menos hinchazón desde la semana 1', 'Piernas y glúteos más firmes', 'Abdomen más plano', 'Más energía durante el día', 'Mejor postura', 'Ropa que vuelve a entrar bien', 'Sin dolor de rodillas', 'Más cómoda con tu cuerpo', 'Resultados que se sostienen'];
  return <section className="py-10 bg-brand-pink-50" data-id="element-247">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-248">
        <div className="text-center mb-8" data-id="element-249">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-3" data-id="element-250">
            Resultados reales
          </div>
          <h2 className="font-display text-2xl md:text-4xl text-gray-900" data-id="element-251">
            Así quedaron ellas
          </h2>
        </div>

        {/* Fotos */}
        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-6" data-id="element-252">
          {transformations.map((t, i) => <div key={i} className="bg-white rounded-2xl p-3 shadow-xl border border-gray-100 w-full sm:w-56" style={{
          transform: `rotate(${t.rotate}deg)`
        }} data-id="element-253">
              <div className="relative rounded-xl overflow-hidden bg-gray-100" data-id="element-254">
                <img src={t.image} alt={t.name} className="w-full h-auto object-cover aspect-square" data-id="element-255" />
                <div className="absolute top-2 left-2 bg-gray-900/80 text-white text-[9px] font-bold uppercase px-2 py-0.5 rounded" data-id="element-256">Antes</div>
                <div className="absolute top-2 right-2 bg-brand-pink-600 text-white text-[9px] font-bold uppercase px-2 py-0.5 rounded" data-id="element-257">Después</div>
              </div>
              <div className="pt-2 pb-1 text-center" data-id="element-258">
                <p className="text-lg font-extrabold text-brand-pink-600 leading-none mb-0.5" data-id="element-259">{t.result}</p>
                <p className="text-xs text-gray-500" data-id="element-260">{t.name} · {t.weeks}</p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-xs text-gray-400 mb-6" data-id="element-261">
          * Los resultados varían según cada persona.
        </p>

        {/* Outcomes compactos — grid de pills */}
        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-262">
          {outcomes.map((outcome, i) => <span key={i} className="bg-white border border-brand-pink-200 text-gray-800 text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-263">
              ✓ {outcome}
            </span>)}
        </div>

        <div className="text-center" data-id="element-264">
          <CTAButton size="large" data-id="element-265">QUIERO EMPEZAR — $16.990</CTAButton>
        </div>
      </div>
    </section>;
}